export default function() {
  const form = document.getElementById('queryFilterForm');
  if(form) {
      const select = form.querySelector('select');
      if(select) {
          select.addEventListener('change', function(){
              const val = this.value.split(':');
              if(val.length === 2) {
                  form.querySelector('input[name="orderby"]').value = val[0];
                  form.querySelector('input[name="order"]').value = val[1];
                  form.submit();
              }
          });
      }
  }
}
